import WebLayout from "../../layout/WebLayout";
import PanelLayout from "../../layout/PanelLayout";
import { pipGetAccessToken } from "../../utils/pip";
import { useNavigate } from "react-router-dom";

const Faq = () => {
    const navigate = useNavigate();
  const { token } = pipGetAccessToken();
  const render = () => {
    return (
      <section className="ct_py_80">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h4 className="ct_fs_24 ct_fw_600 mb-5">
                <a
                onClick={(e) => {
                  e.preventDefault();
                  navigate(-1);
                }}
                class="ct_back_icon ct_fs_18"
              >
                <i class="fa-solid fa-angle-left"></i>
              </a>
                Frequently Asked Questions
              </h4>
              <div class="ct_how_works_collapse">
                <div class="accordion" id="ct_how_works_accordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="ct_works_one">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse_works_one"
                        aria-expanded="true"
                        aria-controls="collapse_works_one"
                      >
                        Lorem ipsum dolor sit amet consectetur
                      </button>
                    </h2>
                    <div
                      id="collapse_works_one"
                      class="accordion-collapse collapse show"
                      aria-labelledby="ct_works_one"
                      data-bs-parent="#ct_how_works_accordion"
                    >
                      <div class="accordion-body">
                        <p class="mb-0 ct_fs_16 ct_line_h_25">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Illo ea modi veritatis. Incidunt, quidem enim!
                          Velit architecto explicabo ipsam sapiente voluptatem
                          natus. Veniam perferendis blanditiis ullam qui
                          architecto doloremque totam.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="ct_works_two">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse_works_two"
                        aria-expanded="false"
                        aria-controls="collapse_works_two"
                      >
                        Lorem ipsum dolor sit amet consectetur
                      </button>
                    </h2>
                    <div
                      id="collapse_works_two"
                      class="accordion-collapse collapse"
                      aria-labelledby="ct_works_two"
                      data-bs-parent="#ct_how_works_accordion"
                    >
                      <div class="accordion-body">
                        <p class="mb-0 ct_fs_16 ct_line_h_25">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Illo ea modi veritatis. Incidunt, quidem enim!
                          Velit architecto explicabo ipsam sapiente voluptatem
                          natus. Veniam perferendis blanditiis ullam qui
                          architecto doloremque totam.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="ct_works_three">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Lorem ipsum dolor sit amet consectetur
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="ct_works_three"
                      data-bs-parent="#ct_how_works_accordion"
                    >
                      <div class="accordion-body">
                        <p class="mb-0 ct_fs_16 ct_line_h_25">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Illo ea modi veritatis. Incidunt, quidem enim!
                          Velit architecto explicabo ipsam sapiente voluptatem
                          natus. Veniam perferendis blanditiis ullam qui
                          architecto doloremque totam.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="ct_works_four">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Lorem ipsum dolor sit amet consectetur
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      class="accordion-collapse collapse"
                      aria-labelledby="ct_works_four"
                      data-bs-parent="#ct_how_works_accordion"
                    >
                      <div class="accordion-body">
                        <p class="mb-0 ct_fs_16 ct_line_h_25">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Illo ea modi veritatis. Incidunt, quidem enim!
                          Velit architecto explicabo ipsam sapiente voluptatem
                          natus. Veniam perferendis blanditiis ullam qui
                          architecto doloremque totam.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="ct_works_five">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        Lorem ipsum dolor sit amet consectetur
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      class="accordion-collapse collapse"
                      aria-labelledby="ct_works_five"
                      data-bs-parent="#ct_how_works_accordion"
                    >
                      <div class="accordion-body">
                        <p class="mb-0 ct_fs_16 ct_line_h_25">
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Illo ea modi veritatis. Incidunt, quidem enim!
                          Velit architecto explicabo ipsam sapiente voluptatem
                          natus. Veniam perferendis blanditiis ullam qui
                          architecto doloremque totam.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };
  return token ? (
    <PanelLayout>{render()}</PanelLayout>
  ) : (
    <WebLayout>{render()}</WebLayout>
  );
};

export default Faq;
